import type { FetchTagPayload } from '@ps/web-core-store';
import { useResolver } from '@ps/web-shared-components';
import { isEqual } from 'lodash';
import React from 'react';

import type { Props as IframeProps } from '@swf/components/Iframe/Iframe';
import Iframe from '@swf/components/Iframe/Iframe';
import { getState, select } from '@swf/core/store';
import { replaceHost } from '@swf/core/utils/domains';

export type Props = {
  tag: string | FetchTagPayload;
  query?: object;
  mitIdData?: object;
  host?: string;
  port?: string;
} & IframeProps;

const ResolverIframe: React.FC<Props> = ({ tag, query, mitIdData, host, port, ...rest }) => {
  const state = getState();
  const language = select.locale.get(state);
  const country = select.account.getCountry(state);
  const site = select.cms.getSiteId(state);
  const timezone = select.account.getTimezone(state);
  const userWebId = select.session.getWebId(state);
  const tagValue = typeof tag === 'string' ? tag : tag?.tag;

  const url = useResolver(tagValue, {
    query: {
      language,
      country,
      site,
      platform: 'Web',
      timezone,
      ...query,
      ...mitIdData,
      TimeZoneId: timezone,
      u: userWebId // Must be a last for license migration app
    }
  });

  const isMartechEmbedded = url.includes('/embedded/martech');
  const iframeHost = isMartechEmbedded ? select.location.getHostname(state) : host;
  const iframePort = isMartechEmbedded ? select.location.getPort(state) : port;

  const targetUrl = url && iframeHost ? replaceHost(url, iframeHost, iframePort) : url;

  return targetUrl ? (
    <Iframe key={targetUrl} src={decodeURIComponent(targetUrl)} tag={tag} {...rest} />
  ) : null;
};

export default React.memo(ResolverIframe, isEqual);
